import { Injectable } from '@angular/core';
import { CommonProvider } from '../common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Platform } from 'ionic-angular';
import { Storage } from '@ionic/storage';


const TOKEN_KEY = 'access_token';

@Injectable()
export class AuthProvider {

    constructor(public http: HttpClient, private commonService: CommonProvider, private storage: Storage, private helper: JwtHelperService, private plt: Platform) {
        this.plt.ready().then(() => {
            this.checkToken();
          });
    }
    authenticationState = new BehaviorSubject(false);
    user = null;
    currAvatar:string;
    token = null;

    private urlLogin        = 'api/v1/auth/login'
    private urlRegister     = 'api/v1/auth/register'
    private urlCheckEmail     = 'api/v1/auth/checkmail'


    checkToken() {
        this.storage.get(TOKEN_KEY).then(token => {
          if (token) {
            let decoded = this.helper.decodeToken(token);
            let isExpired = this.helper.isTokenExpired(token);
     
            if (!isExpired) {
              this.token = token;
              this.user = decoded;
              this.authenticationState.next(true);
            } else {
              this.storage.remove(TOKEN_KEY);
            }
          }
        });
      }

    userLogin(username, password) : Observable<any>{
        let credentials = {
            email: username,
            password: password
        };

        let headers = new HttpHeaders({'Content-Type': 'application/json'});
        let options = {
            headers: headers,
        }
        return this.http.post(this.commonService.apiUrl + this.urlLogin, JSON.stringify(credentials), options)
    }

    userRegister(datas, skill, skillToImprove, hobbies, answers) : Observable<any>{
      let headers = new HttpHeaders({'Content-Type': 'application/json'});
        let options = {
            headers: headers,
        }
      return this.http.post(this.commonService.apiUrl + this.urlRegister, {datas, skill, skillToImprove, hobbies, answers}, options)
    }

    checkEmail(email) : Observable<any>{
      let headers = new HttpHeaders({'Content-Type': 'application/json'});
        let options = {
            headers: headers,
        }
      return this.http.post(this.commonService.apiUrl + this.urlCheckEmail, {email}, options)
    }

    getUserAvatar(){
      return this.currAvatar;
    }

    setUserAvatar(avatarString:string){
      this.currAvatar = avatarString;
    }


}


// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts